
import { inject } from 'vue';
import PlayerEmitter from '../../event/PlayerEmitter';
import DisplayItem from '@/models/DisplayItem';
import Item from '@/models/Item';
import { Options, Prop, Vue, Watch } from 'vue-property-decorator';
import ProgressBar from './ProgressBar.vue';
import ProgressBarData from './ProgressBarData';
import EventBusConstants from '@/constants/EventBusConstants';
import BasicNavigationControl from '../navigation/BasicNavigationControl.vue';
import DeliveryOption from '@/controllers/options/DeliveryOption';
import TestController from '@/controllers/TestController';
@Options({
  components: {
    ProgressBar,
    BasicNavigationControl,
  },
})
export default class InformationHeader extends Vue {
  private sectionChange = false;
  private emitter: PlayerEmitter | undefined = inject('playerEmitter');

  @Prop({ default: '100%' }) readonly width: string | undefined;
  @Prop({ default: '1400px' }) readonly maxWidth: string | undefined;
  private expanded_ = false;
  @Prop() readonly item: DisplayItem | undefined;
  @Prop() readonly progressBarDeliveryOption: DeliveryOption | undefined;
  @Prop({ default: true }) showReviewProgressButton: boolean | undefined;
  @Prop() readonly testController: TestController | undefined;
  @Prop({ default: true }) showItemProgress: boolean | undefined;

  private get title(): string {
    let title = '<b>';
    if (this.item) {
      if (this.item.section.testPart.test.testParts.length > 1) {
        title += this.item.section.testPart.identifier + ' / ';
      }
      title += this.item.section.title + ' / ' + this.item.getItemTitle();
    }
    return title;
  }

  get expanded(): boolean {
    return this.expanded_;
  }

  private get adjustmentClass(): string {
    return this.displayProgressBar ? 'position-adjustment' : '';
  }

  private get displayProgressBar(): boolean {
    return this.progressBarDeliveryOption ? this.progressBarDeliveryOption.getSetting('color') !== undefined : false;
  }

  private get progressBarColor(): string | undefined {
    return this.progressBarDeliveryOption ? this.progressBarDeliveryOption.getSetting('color') : undefined;
  }

  closeReviewIfExpanded(event): void {
    if (this.expanded_ && !this.$el.querySelector('#review-progress-button').contains(event.target)) {
      this.reviewButtonClicked();
    }
  }

  mounted() {
    this.emitter!.on(EventBusConstants.ITEM_PICKED, (data) => {
      if (data.get('sectionReview') === false) {
        this.reviewButtonClicked();
      }
    });
    this.emitter!.on(EventBusConstants.REVIEW_SUBMIT_BUTTON_CLICKED, () => {
      this.reviewButtonClicked();
    });
  }

  @Watch('item')
  private onItemChange(newItem: Item, oldItem: Item): void {
    if (newItem && oldItem) {
      this.sectionChange = newItem.section != oldItem.section;
    } else {
      this.sectionChange = true;
    }
  }

  private get progressBarData(): ProgressBarData {
    let percentage = 0;
    if (this.item) {
      percentage = this.item.getPercentage();
    }
    return new ProgressBarData(percentage, !this.sectionChange);
  }

  private reviewButtonClicked() {
    this.expanded_ = !this.expanded_;

    const reviewButton = this.$el.querySelector('#review-progress-button');
    const reviewButtonIcon = this.$el.querySelector('#review-indicator-icon');

    reviewButtonIcon.classList.remove('fa-angle-down', 'fa-angle-up');
    reviewButton.classList.remove('review-button-regular-border', 'review-button-highlighted-border');

    if (this.expanded_) {
      reviewButtonIcon.classList.add('fa-angle-up');
      reviewButton.classList.add('review-button-highlighted-border');
    } else {
      reviewButtonIcon.classList.add('fa-angle-down');
      reviewButton.classList.add('review-button-regular-border');
    }

    this.emitter!.emit(EventBusConstants.TEST_REVIEW_EVENT, undefined);
  }
}
